<template>
  <div class="container-list">
    <div class="ml20  f18 blue cursor" @click="$router.back()"><i class="el-icon-back"></i> 返回</div>
    <div class="flex">
      <!-- <unitList

       v-show="$store.state.user.company.cCompanyNum==='aaa'"
        @select="getUnit"
        @getFirst="getOne"
      ></unitList> -->
      <div class="flex1">
        <div class="common-page common-head">
          <!-- <div class="common-page common-head-title">
        <i class="icon-tr--detailed" style="padding-right: 5px"></i>
        信息列表
      </div> -->
          <!-- <div class="common-page common-head-end">
                <i class="icon-tr-sign-out"></i>
      </div>-->
        </div>
        <div class="common-page common-body">
          <!-- <div class="common-page common-tool-bar">
        <div class="btn" @click="showDia = true">
          <i class="icon-tr-search"></i>查询
        </div>
        <div class="btn ml10" @click="resetSearch">
          重置
        </div>
       <router-link class="btn ml20" to="/company/pointDetail">
          <i class="icon-tr-newly-added"></i>新增
        </router-link>
      </div> -->
          <div class="common-page common-list">
            <table class="common-table mt20">
              <thead>
                <tr class="mt10">
                  <th>项目名称</th>
                  <th>发现问题</th>
                  <th>解决问题</th>
                  <th>备注</th>
                  <th>操作</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in list" :key="index">
                  <td class="common-add">{{ item.percentage_name }}</td>
                  <td class="common-add">
                    <!-- <el-input v-model="item.percentage_score"></el-input> -->
                    <el-input-number size="small" style="width:50%" v-model="item.percentage_score" :min="0" :max="100" label="描述文字"></el-input-number>
                  </td>
                  <td class="common-add">
                    <!-- <el-input style="width:50%"  v-model="item.percentage_lose"></el-input> -->
                    <el-input-number size="small" style="width:50%" v-model="item.percentage_lose" :min="0" :max="Number(item.percentage_score)" label="描述文字"></el-input-number>
                  </td>
                  <td class="common-add">
                    <el-input style="width:50%" v-model="item.remark"></el-input>
                  </td>

                  <td>
                    <el-button type="primary" size="mini" plain @click="save(item)" v-hasPermi="['report:scoreDetail:insert']">
                      保存
                    </el-button>
                    <!-- <template slot-scope="$props"> -->

                    <el-popconfirm title="确定禁用此记录吗？" class="cursor" @onConfirm="changeStatus(item.id, 0)">
                      <!-- <a slot="reference" class="red"> -->
                      <el-button v-hasPermi="['report:scoreDetail:delete']" slot="reference" type="danger" size="mini" plain>删除</el-button>
                      <!-- </a> -->
                    </el-popconfirm>
                    <!-- </template>  -->
                  </td>

                  <!-- <td class="td-btn">
                <a class="clear-data" @click="del(index)">
                  <i class="icon-tr-delete"></i>
                </a>
              </td> -->
                </tr>
              </tbody>
            </table>
            <!-- <el-table :data="list">
              <el-table-column
                prop="percentage_name"
                label="项目名称"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="percentage_score"
                label="发现问题占比"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="percentage_lose"
                label="解决问题占比"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="remark"
                label="备注"
                align="center"
              ></el-table-column>

              <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                  <router-link
                    :to="{
                      path: '/company/pointDetail',
                      query: { uuid: scope.row.uuid, kid: scope.row.uuid_kid },
                    }"
                  >
                    <el-button size="mini" type="warning" plain>编辑</el-button>
                  </router-link>
                  <el-popconfirm
                    title="确定禁用此记录吗？"
                    class="cursor"
                    @confirm="changeStatus(scope.row.uuid, 0)"
                    @onConfirm="changeStatus(scope.row.uuid, 0)"
                  >
                    <a slot="reference" class="red">
                      <el-button type="danger" size="mini" plain
                        >删除</el-button
                      >
                    </a>
                  </el-popconfirm>
                </template>
              </el-table-column>
            </el-table> -->
          </div>
          <!-- <el-pagination
            background
            layout="prev, pager, next"
            @current-change="pageChange"
            :page-size="10"
            :total="count"
          ></el-pagination> -->
          <div class="btn-box center">
            <div class="l-btn" @click="onSubmit" v-hasPermi="['report:scoreAllDetail:insert']">保存</div>
            <div class="l-btn ml20" @click="$router.back(-1)">返回</div>
          </div>
        </div>
        <el-dialog title="查询" :visible.sync="showDia" :close-on-click-modal="false">
          <fm-generate-form :data="searchForm" :remote="remoteFuncs" :value="editData" ref="searchForm"></fm-generate-form>
          <div class="center">
            <el-button type="primary" @click="searchSubmit" size="small">确定</el-button>
            <el-button @click="showDia = false" size="small">取消</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>
<script>
import unitList from "@/components/unitList";

export default {
  components: {
    unitList,
  },
  data() {
    return {
      // cpNum: "",
      uuid: this.$route.query.id,
      showDia: false,
      searchForm: this.$getForm("weibaoProSearch"),
      remoteFuncs: {},
      params: {
        uuid: "",
        percentage_name: "",
        page: 1,
        starttime: "",
        endtime: "",
      },
      list: [],
      count: 0,
      editData: {},
    };
  },
  created() {
    this.params.uuid = this.uuid;
    this.getList();
  },
  mounted() {},
  watch: {
    // uuid() {
    //   this.params.uuid = this.uuid;
    //   this.getList();
    // },
    $route: {
      handler() {
        log(1111);
        if (this.list) {
          this.getList();
        }
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    onSubmit() {
      this.$post("/score/scoreupdates", this.list).then((res) => {
        this.$message({message: res.msg,type: "success", duration: 700,});
      });
    },
    getList() {
      this.$post("/score/maintenancelists", this.params).then((res) => {
        this.list = res.data.list;
      });
    },
    save(it) {
      console.log(it);
      // if((Number(it.percentage_score)+Number(it.percentage_lose))>100){
      //   this.$message.warning('问题占比不能高于100%！')
      //   return
      // }
      let loading = this.$loading({ background: "rgba(0, 0, 0, 0.6)" });
      let api = it.uuid ? "/score/scoreupdate" : "score/scoreinsert";
      this.$post(api, it)
        .then((res) => {
          // this.$message.success("保存成功");
          this.$message({
									message: '保存成功',
									type: 'success',
									duration: 700,
								});
          loading.close();
          this.getList();
        })
        .catch((err) => {
          loading.close();
        });
    },
    changeStatus(uuid, id) {
      this.$post(`/score/scoredelete/${uuid}`)
        .then((res) => {
          // this.$message.success("删除成功");
          this.$message({
									message: '删除成功',
									type: 'success',
									duration: 700,
								});
          this.getList();
        })
        .catch((e) => {});
    },
    getOne(v) {
      this.cpNum = v;
    },
    getUnit(v) {
      this.cpNum = v;
    },
    resetSearch() {
      this.showDia = false;
      if (this.$refs.searchForm) {
        this.$refs.searchForm.reset();

        this.params = {
          ...this.params,
          page: 1,
          limit: 10,
          ...this.$refs.searchForm.models,
        };
        this.getList();
      }
    },
    searchSubmit() {
      this.$refs.searchForm
        .getData()
        .then((data) => {
          //log(data)
          this.params = { ...this.params, ...data };
          console.log(this.params);
          this.params.page = 1;

          this.getList();
          this.showDia = false;
        })
        .catch((e) => {});
      this.getList();
    },
    pageChange(val) {
      this.params.page = val;
      this.getList();
    },
  },
};
</script>
<style lang="scss">
.common-table > tbody > tr > td {
  color: #000;
}
.f-list {
  flex-wrap: wrap;

  li {
    width: 240px;
    height: 280px;
    margin-right: 40px;
    margin-bottom: 40px;
  }
}

.com-warp {
  margin-top: 10px;

  li {
    font-size: 18px;
    line-height: 34px;
    color: #333;

    padding-left: 10px;
    opacity: 0.7;

    &:nth-child(odd) {
      background: #efeeff;
    }
  }
}

.tab-wrap {
  padding-bottom: 20px;
  border-bottom: 1px solid #ddd;
  margin-bottom: 10px;
}

.f-left {
  width: 260px;
  border: 1px solid #ddd;
  border-radius: 10px;
  padding: 10px;
  height: 600px;
  margin-right: 30px;
}
</style>
